import React, { useState, useEffect } from 'react';
import allTeams from '../../data/teams'; // Adjust the import path as necessary
import { Link } from 'react-router-dom';

// Define the Team interface
interface Team {
    id: number,
    franchiseId: number,
    fullName: string,
    leagueId: number,
    rawTricode: string,
    triCode: string,
    colors : string[],
    conference: string,
    division: string,
    }

// Define the Divisions type
interface Divisions {
    metropolitan: Team[];
    atlantic: Team[];
    pacific: Team[];
    central: Team[];
}

const Teamlisting: React.FC = () => {
    const [teams, setTeams] = useState<Team[]>(allTeams as Team[]);
    const [divisions, setDivisions] = useState<{
        metropolitan: Team[];
        atlantic: Team[];
        pacific: Team[];
        central: Team[];
    }>({
        metropolitan: [],
        atlantic: [],
        pacific: [],
        central: [],
    });
    // Helper function to filter teams by conference and division
    const filterTeams = (conference: string, division: string): Team[] => {
        return teams.filter(team => team.conference === conference && team.division === division);
    };

    useEffect(() => {
        setDivisions({
            metropolitan: filterTeams('Eastern', 'Metropolitan'),
            atlantic: filterTeams('Eastern', 'Atlantic'),
            pacific: filterTeams('Western', 'Pacific'),
            central: filterTeams('Western', 'Central'),
        });


    }, [teams]);

    const renderDivision = (divisionName: string, teams: Team[]) => {
        return (
            <div className="division">
                <h3>{divisionName}</h3>
                {teams.map(team => (
                    <Link 
                        to={`/team/${team.rawTricode}`} 
                        className="team-item" 
                        style={{ textDecoration: 'none', color: 'black' }}
                        key={team.id}
                    >
                        <div className="team-item">
                        <img 
                                    width={60} 
                                    src={`https://assets.nhle.com/logos/nhl/svg/${team.triCode}_dark.svg`} 
                                    alt={`${team.fullName} logo`}
                                />
                            <h4>
                                {team.fullName}
                            </h4>
                        </div>
                    </Link>
                ))}
            </div>
        );
    };

    return (
        <div className="team-list">
            <h1>NHL Teams</h1>
            
            <h2>Eastern Conference</h2>
            <div className="conference">
                {renderDivision('Metropolitan', divisions.metropolitan)}
                {renderDivision('Atlantic', divisions.atlantic)}
            </div>
            
            <h2>Western Conference</h2>
            <div className="conference">
                {renderDivision('Pacific', divisions.pacific)}
                {renderDivision('Central', divisions.central)}
            </div>
        </div>
    );
};

export default Teamlisting;